import { clsx } from 'clsx';
import { useMatch } from 'react-router';

import { LinkWithQuery } from '../../components/LinkWithQuery/LinkWithQuery';

export const DEFAULT_12M_PRICING_OPTION = 'SELLER_FREE_BUYER_PAYS';
export const DEFAULT_30D_PRICING_OPTION = 'SELLER_FREE_BUYER_PAYS';

export const PayLinksNavigation = () => {
  return (
    <nav>
      <div className="flex w-full items-center justify-between border-b border-london-95">
        <div className="flex w-full gap-[2rem] overflow-auto [-ms-overflow-style:none] [scrollbar-width:none] m900:gap-[4rem] [&::-webkit-scrollbar]:hidden">
          <PayLinkNavBarLink to="/pay/pay-links/universal/">
            Universal link
          </PayLinkNavBarLink>
          <PayLinkNavBarLink to="/pay/pay-links/package/">
            Package links
          </PayLinkNavBarLink>
          <PayLinkNavBarLink to="/pay/pay-links/custom/">
            Custom links
          </PayLinkNavBarLink>

          <a
            href="https://support.iwoca.co.uk/en/collections/2145896-iwocapay-the-simple-checkout-for-your-invoices"
            target="_blank"
            rel="noopener noreferrer"
            className="relative mb-s cursor-pointer whitespace-nowrap pb-s pl-0 pr-s pt-l text-s font-med leading-[1.5] text-black-90 no-underline last:ml-auto hover:text-primary-40"
          >
            Pay links FAQ
          </a>
        </div>
      </div>
    </nav>
  );
};

const PayLinkNavBarLink = ({
  to,
  children,
}: {
  to: string;
  children: React.ReactNode;
}) => {
  return (
    <NavBarLink
      to={to}
      className="relative mb-s cursor-pointer whitespace-nowrap pb-s pl-0 pr-s pt-l text-s font-med leading-[1.5] text-black-90 no-underline last:ml-auto hover:text-primary-40"
      activeClass="border-b-2 border-black-90"
    >
      {children}
    </NavBarLink>
  );
};

const NavBarLink = ({
  to,
  children,
  className,
  activeClass,
  isExternalLink,
  ...props
}: {
  to: string;
  children: React.ReactNode;
  className?: string;
  activeClass?: string;
  isExternalLink?: boolean;
}) => {
  const match = useMatch(to + '*');
  const getLinkClassName = (): string | undefined => {
    if (!activeClass) return className;

    return clsx(className, {
      [activeClass]: match,
    });
  };

  return isExternalLink ? (
    <a {...props} href={to} className={getLinkClassName()}>
      {children}
    </a>
  ) : (
    <LinkWithQuery {...props} to={to} className={getLinkClassName()}>
      {children}
    </LinkWithQuery>
  );
};
